export const GITIGNORE_TEMPLATES = {
  node: {
    label: 'Node.js',
    content: `node_modules/\nnpm-debug.log*\nyarn-debug.log*\nyarn-error.log*\n.env\n.env.local\ndist/\nbuild/\n`,
  },
  react: {
    label: 'React / CRA',
    content: `node_modules/\nbuild/\n.env\n.env.local\nnpm-debug.log*\nyarn-debug.log*\nyarn-error.log*\n.DS_Store\n`,
  },
  python: {
    label: 'Python',
    content: `__pycache__/\n*.py[cod]\n*.egg-info/\n.venv/\nvenv/\n.env\ndist/\nbuild/\n.pytest_cache/\n`,
  },
  java: {
    label: 'Java / Maven',
    content: `target/\n*.class\n*.jar\n*.war\n.idea/\n*.iml\n`,
  },
  vscode: {
    label: 'VS Code',
    content: `.vscode/*\n!.vscode/extensions.json\n`,
  },
  macos: {
    label: 'macOS',
    content: `.DS_Store\n.AppleDouble\n.LSOverride\n`,
  },
  windows: {
    label: 'Windows',
    content: `Thumbs.db\nDesktop.ini\n$RECYCLE.BIN/\n`,
  },
  intellij: {
    label: 'IntelliJ / JetBrains',
    content: `.idea/\n*.iml\nout/\n`,
  },
}

export const buildGitignore = (keys) =>
  keys
    .map((key) => `# ${GITIGNORE_TEMPLATES[key].label}\n${GITIGNORE_TEMPLATES[key].content}`)
    .join('\n')
